import { useAppDispatch } from '@/app/hooks';
import { inClinicApi } from '@/app/services/inClinic';
import { Button } from '@/components/ui/button';

export function MainViewRefreshButton() {
  const dispatch = useAppDispatch();

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="size-10"
      aria-label="Refresh"
      title="Refresh"
      onClick={() =>
        dispatch(
          inClinicApi.util.invalidateTags([
            'InClinicRecips',
            'InClinicRecipQueue',
            'InClinicEmbryos',
            'InClinicFrozenEmbryos',
          ]),
        )
      }
    >
      <i className="pi pi-refresh" />
    </Button>
  );
}
